import { useMemo, useState } from 'react';
import get from 'lodash/get';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { PATIENT } from '../../../constants/props';
import { POPOVER_MENU_ITEMS } from '../../../constants';

export function useSimpleForm({
  memberId,
  targetUser,
  changeRole,
  sendPatientInvite,
  inviteFamilyMember,
}) {
  const [simpleFormFields, setFormFields] = useState({});
  const role = get(simpleFormFields, 'role');
  const useCustomFields = useMemo(() => role === PATIENT, [role]);
  const { email, phoneNumber, id } = targetUser;

  const simpleFormInitState = useMemo(
    () =>
      useCustomFields
        ? {
            [PROFILE_FIELDS_TYPES.ROLE]: PATIENT,
            [PROFILE_FIELDS_TYPES.PHONE_NUMBER]: phoneNumber,
            [PROFILE_FIELDS_TYPES.EMAIL]: email,
          }
        : { [PROFILE_FIELDS_TYPES.ROLE]: role },
    [useCustomFields],
  );

  const handleActions = (type, formState) => {
    if (type === POPOVER_MENU_ITEMS.CHANGE_ROLE) {
      changeRole({ memberId, ...formState });
    }
    if (type === POPOVER_MENU_ITEMS.INVITE_MEMBER) {
      inviteFamilyMember(formState);
    }
    if (type === POPOVER_MENU_ITEMS.INVITE_PATIENT) {
      sendPatientInvite({ ...formState, userId: id });
    }
  };

  const simpleFormHandlers = () => {
    return {
      [POPOVER_MENU_ITEMS.CHANGE_ROLE]: formState =>
        handleActions(POPOVER_MENU_ITEMS.CHANGE_ROLE, formState),
      [POPOVER_MENU_ITEMS.INVITE_MEMBER]: formState =>
        handleActions(POPOVER_MENU_ITEMS.INVITE_MEMBER, formState),
      [POPOVER_MENU_ITEMS.INVITE_PATIENT]: formState =>
        handleActions(POPOVER_MENU_ITEMS.INVITE_PATIENT, formState),
    };
  };
  return {
    setFormFields,
    useCustomFields,
    simpleFormHandlers,
    simpleFormInitState,
  };
}



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/useSimpleForm.js